// @flow

import Model from "app/models/Model";

export default class TimelineItemComment extends Model {
    static key = 1;

    key: number;
    rowid: number;
    author_id: number;
    author_name: string;
    author_image: string;
    author_profile_id: any;
    author_slug: string;
    message: string;
    send_time: Date;

    constructor() {
        super();
        this.key = this.constructor.key++;
    }

    normalize() {
        this.normalizeDate("send_time");
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TimelineItemComment.js